import { Injectable } from '@angular/core';
import { loadTranslations } from '@angular/localize';
import { ActivatedRoute } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AccountService {
  readonly LOCALES = ['de', 'en'];
  readonly LOCALSTORAGE_KEY_DONOTSHOW = 'business-one.io.einvoice-viewer.do-not-show-again';
  readonly LOCALSTORAGE_KEY_LOCALE = 'business-one.io.einvoice-viewer.locale';
  readonly QUERYPARAMETER_KEY_LOCALE = 'lang';
  private locale: string | undefined;

  constructor(private route: ActivatedRoute) {
    //void this.init();
  }

  async init() {
    this.locale = this.getActiveLocale();
    const translations = await fetch(`assets/i18n/${this.Locale}.json`);
    if (translations.ok) {
      loadTranslations(JSON.parse(await translations.text()));
    }
  }
  public get Locale(): string {
    return this.locale || 'de';
  }
  public getActiveLocale(): string | undefined {
    const storedLocale = localStorage.getItem(this.LOCALSTORAGE_KEY_LOCALE) as string | undefined;
    if (storedLocale) {
      const locale = storedLocale?.toLocaleLowerCase();
      return locale;
    } else {
      const queryLocale = new URLSearchParams(window.location.search).get(this.QUERYPARAMETER_KEY_LOCALE);
      return this.LOCALES.some(x => x === queryLocale?.toLocaleLowerCase())
        ? queryLocale?.toLocaleLowerCase()
        : undefined;
    }
  }

  public setActiveLocale(locale: string): void {
    localStorage.setItem(this.LOCALSTORAGE_KEY_LOCALE, locale);
    window.location.reload();
  }

  public getLocales(): string[] {
    return this.LOCALES;
  }

  public showStartPage(): boolean {
    const acceptDateStr = localStorage.getItem(this.LOCALSTORAGE_KEY_DONOTSHOW);
    const acceptDate = acceptDateStr ? new Date(acceptDateStr) : undefined;
    if (acceptDate) {
      const now = new Date();
      const diff = now.getTime() - acceptDate.getTime();
      const diffDays = diff / (1000 * 3600 * 24);
      return diffDays < 30 ? false : true;
    } else {
      return true;
    }
  }
  public setDonotshowStartpage(): void {
    localStorage.setItem(this.LOCALSTORAGE_KEY_DONOTSHOW, new Date().toISOString());
  }
}
